const API_URLS = {
  production: () => `${window.location.protocol}//api.atg.plus`,
  test: "https://api.testme.com.tr",
  staging: "https://api.staging.tr",
};

const MERCURE_URLS = {
  production: "https://atg.plus/.well-known/mercure?topic=%2Fperson-approval",
  test: "http://atg.plus:5000/.well-known/mercure?topic=%2Fperson-approval",
  staging: "http://atg.plus:5000/.well-known/mercure?topic=%2Fperson-approval",
};

const resolveEnvironment = () => {
  const env = process.env.REACT_APP_URL_ENVIRONMENT;
  if (env === "production" || env === "test" || env === "staging") {
    return env;
  }
  if (env === "development") {
    return "test";
  }

  const host = window.location.hostname;
  if (host.includes("atg.plus")) {
    return "production";
  }
  if (host.includes("staging.tr")) {
    return "staging";
  }
  return "test";
};

export const URL_ENVIRONMENT = resolveEnvironment();

export const URL =
  typeof API_URLS[URL_ENVIRONMENT] === "function"
    ? API_URLS[URL_ENVIRONMENT]()
    : API_URLS[URL_ENVIRONMENT];

export const MERCURE_URL = MERCURE_URLS[URL_ENVIRONMENT] || MERCURE_URLS.test;

export const atgCompanyUid = "CF1A1BE";
export const mondiCompanyUid = "C971873";
export const turkiyeSigortaCompanyUid = "C9B78BC";
export const superpakCompanyUid = "53C45D";
export const kademCompanyUid = "C0D07DD";
